<template>
  <FullscreenFrontageDialog ref="frontageDialog">
    <template>
      <UnsavedChangesConfirmation :show="true"
                                  :subject="subject"
                                  @onCloseButtonClicked="handleClose"
                                  @onCancelClicked="handleClose"
                                  @onOkClicked="handleSubmit"/>
    </template>
  </FullscreenFrontageDialog>
</template>

<script>
import {FullscreenFrontageDialog, UnsavedChangesConfirmation} from "@/modules/common/components";

export default {
  name: "UnsavedChangesDialog",
  components: {FullscreenFrontageDialog, UnsavedChangesConfirmation},
  props: {
    subject: {
      type: String,
      required: true
    }
  },
  methods: {
    handleClose() {
      this.$refs.frontageDialog.handleClose();
    },
    handleSubmit() {
      this.$refs.frontageDialog.handleSubmit();
    }
  }
}
</script>
